import BuyingFilter from "../../../components/filteration/buyingFilter";
import ShopAdds from "../../../components/shopAds/ShopAdds";
import Shops from "../../../components/Multipleshopprofile/Components/Shops/Shops";
import { Container, Row, Col, Pagination } from "react-bootstrap";
import ShareModel from "../../../components/Sharemodel";
import ShareOption from "../../../components/Shareoption";
import BackArrow from "../../../components/backArrow";
import { useBuyRetailerState } from "./hooks/useBuyRetailerState";
import { RETAILER_ALLOWED_CONNECT_TYPES } from "../../../constants/businessTypeConnectionRules";

const BuyRetailer = () => {
  const {
    isloading,
    createshopcategory,
    shopCategory,
    shopCategorytwo,
    showmodal,
    showshare,
    dataCategory,
    shopdata,
    itemmdata,
    filters,
    page,
    totalPages,
    handleClosemodal,
    handleShow,
    handleCloseshare,
    handleShowshare,
    Handledata,
    Mydata,
    Handleadditioanalshop,
    FilterHandler,
    FilterHandleritem,
    handlePageChange,
  } = useBuyRetailerState();

  // Generate pagination items dynamically
  let items = [];
  for (let number = 1; number <= totalPages; number++) {
    items.push(
      <Pagination.Item
        key={number}
        active={number === page}
        onClick={() => handlePageChange(number)}
      >
        {number}
      </Pagination.Item>,
    );
  }

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        showmodal={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
      />
      <Container>
        <Row>
          <Col xs="12" className="d-lg-none screenHeight">
            <BackArrow back="/BuyingSide" mystyle="pt-1 ps-2" />
          </Col>
          <Col lg="4" className="screenHeight background-image buy-retailer-content">
            <div className="border b-radius height_100">
              <BuyingFilter
                FilterHandleritem={FilterHandleritem}
                Handleadditioanalshop={Handleadditioanalshop}
                FilterHandler={FilterHandler}
                dataCategory={dataCategory}
                createshopcategory={createshopcategory}
                shopCategory={shopCategory}
                Handledata={Handledata}
                shopCategorytwo={shopCategorytwo}
                Mydata={Mydata}
                additionalShopCategoryData={filters}
              />
            </div>
          </Col>
          <Col lg="8" className="screenHeight buy-retailer-content">
            <div className="border b-radius ps-3 pe-3">
              <div className="d-none d-lg-block">
                <BackArrow back="/BuyingSide" mystyle="pt-1 ps-2" />
              </div>
              <ShopAdds businessType="retailerShop" platform="retailerShop" />
              <Shops
                link="/retailer-userprofile"
                title="Retailer"
                isloading={isloading}
                data={0}
                handleShow={handleShow}
                shopdata={shopdata}
                itemmdata={itemmdata}
                isServerPaginated={true}
                allowedConnectBusinessTypes={RETAILER_ALLOWED_CONNECT_TYPES}
              />

              {/* Dynamic Pagination Controls */}
              {totalPages > 1 && shopdata?.length > 0 && (
                <div className="d-flex justify-content-center mt-4 mb-4">
                  <Pagination>
                    <Pagination.First
                      onClick={() => handlePageChange(1)}
                      disabled={page === 1}
                    />
                    <Pagination.Prev
                      onClick={() => handlePageChange(page - 1)}
                      disabled={page === 1}
                    />
                    {items}
                    <Pagination.Next
                      onClick={() => handlePageChange(page + 1)}
                      disabled={page === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(totalPages)}
                      disabled={page === totalPages}
                    />
                  </Pagination>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BuyRetailer;
